import React from "react";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { ProfileModalContentWrapper } from "../shared/Modal/Modal.styles";
import { SuccessMessageWrapper } from "./EditPaymentMethodModal.styles";
import { EditPaymentMethodSuccessMessage } from "./EditPaymentMethodSuccessMessage";

interface EditPaymentMethodSuccessConfirmationProps {
  onPrimaryAction: () => void;
  updatedPaymentMethod: {
    card_brand: string;
    last_four_digits: string;
  };
}

export const EditPaymentMethodSuccessConfirmation: React.FC<
  EditPaymentMethodSuccessConfirmationProps
> = ({ onPrimaryAction, updatedPaymentMethod }) => {
  const { deviceType } = useDeviceHook();

  return (
    <SuccessMessageWrapper deviceType={deviceType}>
      <ProfileModalContentWrapper>
        <EditPaymentMethodSuccessMessage
          onPrimaryAction={onPrimaryAction}
          updatedPaymentMethod={updatedPaymentMethod}
        />
      </ProfileModalContentWrapper>
    </SuccessMessageWrapper>
  );
};
